import React from 'react';
import styled from 'styled-components';
import { Close, Success as SuccessIcon } from '../../icons';

export const SuccessScreen = ({ onClose }) => {
  const onBtnClick = e => {
    e.preventDefault();
    onClose();
  };
  return (
    <Wrap>
      <Button onClick={onBtnClick}>
        <Close />
      </Button>
      <div>
        <SuccessIcon />
      </div>
      <Heading>Your request was successfully submitted!</Heading>
    </Wrap>
  );
};

const Heading = styled.h4`
  font-weight: 600;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  width: 260px;
  max-width: 100%;
  margin: 30px auto 0;
`;

const Button = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 0;
  line-height: 0;
`;

const Wrap = styled.div`
  position: absolute;
  text-align: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  z-index: 2;
`;
